const cf7OpinionForm = () => {

    const resultFormBlock = document.getElementById('result-form-block');
    const resultPageText = document.getElementById('result-page-text');
    const resultMessageBlock = document.getElementById('result-message-block');

    if(!resultFormBlock){
        return;
    }

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        resultFormBlock.style.display    = 'none';
        resultPageText.style.display    = 'none';
        resultMessageBlock.style.display = 'block';
    }, false );

};

export default cf7OpinionForm;

